import chroma from "chroma-js";
import { ConfigSchema } from "./interfaces";

const myConfig: ConfigSchema = {
  app: {
    API_URL: "https://api.spotlive.it/api",
    STATIC_URL: "https://api.spotlive.it/static",
    APPSTORE_URL: "https://apps.apple.com/app/spotlive/id6448094917",
    PLAYSTORE_URL: "https://play.google.com/store/apps/details?id=com.spotlive",
  },

  api_keys: {
    // GOOGLE_MAPS: process.env.REACT_APP_GOOGLE_MAPS_API_KEY!,
  },

  customization: {
    global: {
      palette: {
        primary: "#00a19c",
        secondary: "#00dbd4",
        text_primary: "#00a19c",
        backgroundDark: "#1D1D1B",
        backgroundLight: "#262626",
        backgroundLightBright: "#333333",
        darkGrey: "#404040",
        mediumGrey: "#abb7b7",
        lightGrey: "#EDD5DD",
        successGreen: "#4BB543",
        red: "#d64541",
        errorRed: "#cc0000",
        whiteSmoke: "#F5F5F5",
      },

      fonts: {
        main: {
          font_family:
            'Helvetica Neue, Helvetica, Arial, "Lucida Grande", sans-serif',
        },
        typewriter: {
          font_family: "Cutive Mono, monospace",
          google: {
            font_name: "Cutive Mono",
            font_weights: [400, 800],
          },
        },
      },
    },
  },

  validation: {
    user: {
      username: {
        length: { min: 3, max: 15 },
        regex: /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{0,}$/,
      },
    },

    // MEDIA
    media: {
      profilePicture: {
        aspectRatio: 3 / 4,
        width: { max: 2100 },
        height: { max: 2800 },
      },
      eventImage: {
        aspectRatio: 1,
        width: { max: 1440 },
        height: { max: 1440 },
      },
      organizerImage: {
        aspectRatio: 1,
        width: { max: 600 },
        height: { max: 600 },
      },
    },
  },
};

export const palette = myConfig.customization.global.palette;
export const fonts = myConfig.customization.global.fonts;
export { myConfig as myConfig };
